// App
export const SET_COUNTRY = 'setCountry'
export const SET_LANGUAGE = 'setLanguage'
export const SET_BACK_BUTTON = 'setBackButton'
export const SET_COUNTRIES = 'setCountries'

// Auth
export const SET_AUTH_TOKEN = 'setAuthToken'
export const SET_AUTH_USER = 'setAuthUser'
export const SET_REDIRECT_URL = 'setRedirectUrl'
export const LOGOUT = 'logout'
export const SET_IP_ADDRESS = 'setIpAddress'

// Payment
export const SET_OPEN_PAYMENTS = 'setOpenPayments'

// Payment Contract
export const SET_PAYMENT_CONTRACTS = 'setPaymentContracts'

// Signup
export const SET_ADDRESS_CONFIRMED = 'setAddressConfirmed'
export const SET_IS_SIZE_MODAL_OPEN = 'setIsSizeModalOpen'
export const SET_FORM_FIELD = 'setFormField'
export const SET_ADDRESS_FORM_FIELD = 'setAddressFormField'
export const SET_DESIGNS = 'setDesigns'
export const SET_CURRENT_STEP = 'setCurrentStep'
export const SET_PREVIOUS_ROUTE = 'setPreviousRoute'
export const SET_PREVIOUS_ROUTE_PARAMS = 'setPreviousRouteParams'
export const SET_NEXT_ROUTE = 'setNextRoute'
export const SET_SIGNUP_STATE = 'setSignupState'

// Loqate
export const SET_LAST_SEARCH_QUERY = 'lastSearchQuery'
export const SET_ADDRESS_IS_VERIFIED = 'addressIsVerified'

// Spaaza
export const SET_SPAAZA_USER = 'setSpaazaUser'
export const CLEAR_SPAAZA_USER = 'clearSpaazaUser'
export const SET_SPAAZA_WALLET = 'setSpaazaWallet'

// Women Signup
export const SET_WOMEN_FORM_FIELD = 'setWomenFormField'
export const SET_WOMEN_ADDRESS_CONFIRMED = 'setWomenAddressConfirmed'
export const SET_WOMEN_ADDRESS_FIELD = 'setWomenAddressField'
export const WOMEN_RESET = 'womenReset'
export const WOMEN_SET_COMPLETE_STATE = 'womenSetCompleteState'

// Webshop
export const ADD_TO_CART = 'addToCart'
export const REMOVE_CART_ITEM = 'removeCartItem'
export const EDIT_CART_ITEM_QUANTITY = 'editCartItemQuantity'
export const SET_WEBSHOP_ADDRESS = 'setWebshopAddress'
export const SET_WEBSHOP_FIRSTNAME = 'setWebshopFirstname'
export const SET_WEBSHOP_LASTNAME = 'setWebshopLastname'
export const SET_WEBSHOP_PHONENUMBER = 'setWebshopPhoneNumber'
export const SET_WEBSHOP_MEMBERID = 'setWebshopMemberId'
export const SET_WEBSHOP_SHIPPING = 'setWebshopShipping'
export const SET_IS_WALLET_FROZEN = 'setIsWalletFrozen'
export const RESET_CART = 'resetCart'

// Flags
export const SET_FLAGS = 'setFlags'
export const SET_FLAGS_IS_FETCHED = 'setFetched'

// Feature Flags
export const SET_FEATURE_FLAGS = 'setFeatureFlags'
